import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import withSizes, { Sizes } from 'react-sizes'

interface LanguageSwitcherProps {
  width?: number
  className?: string
  isHeaderDark?: boolean
}

const mapSizesToProps = ({ width }: Sizes): Partial<LanguageSwitcherProps> => ({
  width: width,
})

export const languageOptions = [
  { label: '🇺🇸', value: 'en' },
  { label: '🇫🇷', value: 'fr' },
]

const LanguageSwitcher = (props: LanguageSwitcherProps) => {
  const { t, i18n } = useTranslation('common')
  const [lngOptions, setLngOptions] = useState([])

  useEffect(() => {
    const lgLanguageOptions =
      i18n.resolvedLanguage == 'en'
        ? [
            { label: '🇺🇸 English', value: 'en' },
            { label: '🇫🇷 French', value: 'fr' },
          ]
        : [
            { label: '🇺🇸 Anglais', value: 'en' },
            { label: '🇫🇷 Français', value: 'fr' },
          ]

    const mdLanguageOptions = [
      { label: '🇺🇸 EN', value: 'en' },
      { label: '🇫🇷 FR', value: 'fr' },
    ]

    if (props.width >= 768) {
      setLngOptions(lgLanguageOptions)
    } else if (props.width >= 480) {
      setLngOptions(mdLanguageOptions)
    } else {
      setLngOptions(languageOptions)
    }
  }, [props.width, i18n.resolvedLanguage])

  return (
    <Select
      id="language-switcher"
      className={props?.className}
      defaultValue={lngOptions.find((option) => option.value === i18n.resolvedLanguage) ?? lngOptions[0]}
      value={lngOptions.find((option) => option.value === i18n.resolvedLanguage) ?? lngOptions[0]}
      options={lngOptions}
      onChange={(option) => {
        void i18n.changeLanguage(option.value)
      }}
      components={{ IndicatorSeparator: () => null }}
      isSearchable={false}
      menuPortalTarget={document.body}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      classNames={{
        control: () => 'language-switcher__control',
        singleValue: () => {
          return props?.isHeaderDark ? 'language-text-light-grey' : 'language-text-dark-grey'
        },
        dropdownIndicator: () => 'language-switcher__dropdown-indicator',
        valueContainer: () => 'language-switcher__value-container',
        option: ({ isSelected, isFocused }) =>
          `language-switcher__option ${isSelected ? 'is-selected' : ''} ${isFocused ? 'is-focused' : ''}`,
      }}
    />
  )
}

export default withSizes(mapSizesToProps)(LanguageSwitcher)
